import { ReactNode } from 'react'

import { StyledList, StyledListItem, ZenkakuSpace } from '../TextStyle'
import { LinkText } from '@/components/elements/LinkText'

export const snsItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>第1条（総則）</h3>
        <p>
          トライアルグループソーシャルメディア公式アカウント利用規約（以下「本規約」という）は、トライアルグループ（株式会社トライアルホールディングス及びそのグループ会社※をいう）が運営するソーシャルメディア公式アカウント及びそれに付随するサービス（以下総称して「本サービス」という）の利用（利用には閲覧行為も含む。以下同様）につき、本サービスの利用者（以下「利用者」という）が遵守すべき事項を定めるものです。
          <br />
          ※株式会社トライアルホールディングスのグループ会社は
          <LinkText path="/company/overview/" text="こちら" />
          です。
        </p>
      </>
    ),
    id: 'policy1',
  },
  {
    children: (
      <>
        <h3>第2条（本規約の範囲）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            本規約は、本サービスのすべての利用者に適用されるものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            利用者が本サービスを利用した場合、本規約を承諾したものとみなします。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループがオンライン又はその他の方法で随時提示する諸規定は、本規約の一部を構成するものとします。ただし、諸規定が本規約と異なる場合は諸規定が優先するものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            本規約と、本サービスを提供した各ソーシャルメディア運営会社が定めている利用規約や方針との間に抵触が生じた場合、当該ソーシャルメディア運営会社の利用規約や方針に従うものとします。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy2',
  },
  {
    children: (
      <>
        <h3>第3条（利用者情報の取扱い）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            利用者がトライアルグループに登録した個人情報は、トライアルグループが保有し、利用者の同意を得ることなく第三者に提供しないものとします。登録された個人情報は、トライアルグループの
            <LinkText
              path="/legal/privacy-policy/"
              text="プライバシーポリシー"
            />
            に規定する利用目的以外には使用しないものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、利用者が本サービスにおいて、すべてのユーザーに公開すると設定している情報へのアクセスを行います。
          </StyledListItem>
          <StyledListItem listType="article">
            利用者が本サービスを利用した場合、トライアルグループが定めるプライバシーポリシーに同意したものとみなします。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy3',
  },
  {
    children: (
      <>
        <h3>第4条（本規約の変更）</h3>
        <p>
          トライアルグループは利用者の承諾なしに、本規約を変更することができるものとします。変更後の規約については、トライアルグループが、オンライン上に表示した時点より、効力を生じるものとします。
        </p>
      </>
    ),
    id: 'policy4',
  },
  {
    children: (
      <>
        <h3>第5条（禁止事項）</h3>
        <p>本サービスの利用に際し、次の各号に該当する行為を禁止します。</p>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            トライアルグループ、他の利用者、第三者の著作権、肖像権、その他知的財産権を侵害する行為。また、そのおそれのある行為。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループ、他の利用者、第三者の財産、信用、プライバシー等を侵害する行為。またその恐れのある行為。
          </StyledListItem>
          <StyledListItem listType="article">
            真偽を問わず、トライアルグループ、他の利用者、第三者を誹謗中傷する行為。
          </StyledListItem>
          <StyledListItem listType="article">
            個人情報（メールアドレス、住所、電話番号、その他プライベート情報）を、トライアルグループ及び当該個人の事前の承諾なく、他の利用者や第三者に送付、伝達、開示、複写、書き込みをする行為。
          </StyledListItem>
          <StyledListItem listType="article">
            他の利用者・第三者の著作物をトライアルグループの事前の承諾なく、他の利用者や第三者に送付、開示、複写、書き込みをする行為。
          </StyledListItem>
          <StyledListItem listType="article">
            ウィルス、ハッキング等によりトライアルグループの運用を妨害又は破壊する行為。
          </StyledListItem>
          <StyledListItem listType="article">
            脅し、猥褻、名誉毀損、差別行為、政治活動、宗教活動、又はそれらにつながる行為。
          </StyledListItem>
          <StyledListItem listType="article">
            氏名やアドレスを借用してコンピュータに侵入する行為。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループの事前の許可なく営業活動、人材採用活動、又はアフィリエイト、営業目的サイトへの誘導、リンク等、営利を目的として行う一切の行為。
          </StyledListItem>
          <StyledListItem listType="article">
            本サービスないしトライアルグループの運用を妨げる行為、トライアルグループの信頼を毀損する行為、又は他の利用者もしくはトライアルグループに不利益を与える行為。
          </StyledListItem>
          <StyledListItem listType="article">
            公序良俗に反する行為、犯罪行為又はそれらと密接に関連する行為。
          </StyledListItem>
          <StyledListItem listType="article">
            法律、法令違反又はそれらに密接に関連する行為。
          </StyledListItem>
          <StyledListItem listType="article">
            猥褻な映像・音声・文字等の情報を提供する行為があった、もしくはそれを試みる行為。
          </StyledListItem>
          <StyledListItem listType="article">
            あらゆる種類の広告バナー交換やリンク交換を含む広告バナーの表示等の行為。
          </StyledListItem>
          <StyledListItem listType="article">
            薬機法に抵触する恐れのある投稿・推奨行為。
          </StyledListItem>
          <StyledListItem listType="article">
            各ソーシャルメディア運営会社が禁止している行為。
          </StyledListItem>
          <StyledListItem listType="article">
            その他本サービスの目的に反する行為。
          </StyledListItem>
          <StyledListItem listType="article">
            その他トライアルグループが不適切と判断する行為。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy5',
  },
  {
    children: (
      <>
        <h3>第6条（禁止行為に対する措置）</h3>
        <p>
          故意過失を問わず、利用者が前条各号の行為を行った、又は行う恐れがあるとトライアルグループが判断した場合、トライアルグループは、事前に通告することなく、次の措置のいずれか、又は複合させた措置を取ることができます。
        </p>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            コメント等の書き込み、投稿内容の削除。
          </StyledListItem>
          <StyledListItem listType="article">
            サービスの利用制限。
          </StyledListItem>
          <StyledListItem listType="article">
            プラットフォームページ内のメッセージ又は私信メールでの注意・勧告。
          </StyledListItem>
          <StyledListItem listType="article">
            (1)～(3)
            の処置を講じたことに関するプラットフォームページ内のメッセージ又は私信メールでのアナウンス。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy6',
  },
  {
    children: (
      <>
        <h3>第7条（サ－ビスの変更）</h3>
        <p>
          トライアルグループは、本規約のほか別途定める個別の規定等に基づき、利用者に本サービスを提供します。トライアルグループは、利用者の承諾なく、本サ－ビスの内容を変更する（改廃を含む）ことができます。
        </p>
      </>
    ),
    id: 'policy7',
  },
  {
    children: (
      <>
        <h3>第8条（知的財産権）</h3>
        <p>
          トライアルグループによって本サービスに提供されるテキスト、ソフトウェア、音楽、音声、写真、グラフィックス、ビデオ、ページレイアウト、デザインやその他のマテリアルを含む一切のコンテンツに係る著作権、商標権、サービスマークに関する権利、特許権、又はその他の所有権及び法律によって保護される権利はトライアルグループに帰属するものとします。
        </p>
      </>
    ),
    id: 'policy8',
  },
  {
    children: (
      <>
        <h3>第9条（トライアルグループの利用）</h3>
        <p>
          利用者が投稿したコメント・画像・動画などの情報はトライアルグループが本人の承諾を得ることなく、本サービスの広告・宣伝、利用促進の目的で、印刷物・会報誌・ホームページ等に掲載することもあります。
        </p>
      </>
    ),
    id: 'policy9',
  },
  {
    children: (
      <>
        <h3>第10条（紛争の解決）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            本規約に定めのない事項又は本規約の解釈に疑義がある場合、もしくは利用者とトライアルグループの間に紛争が生じた場合、信義に則り誠実にこれを解決するものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            利用者とトライアルグループの間で訴訟の必要が生じた場合、株式会社トライアルホールディングスの本店所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy10',
  },
  {
    children: (
      <>
        <h3>第11条（免責事項）</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            トライアルグループは、本サービスの全ての利用者に対し、利用者が提供する全ての情報について、その正確性、有用性、最新性、適切性等その内容について何ら法的保証をするものではなく、何らの責任を負うものでもありません。
          </StyledListItem>
          <StyledListItem listType="article">
            利用者のブラウザ、閲覧環境により、本サービスの利用に支障が生じることがございます。利用者が本サービスを利用できなかったことにより生じた損害については、トライアルグループは一切の責任を負わないものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            ソーシャルメディアは外部の法人により運営されているものであり、その機能や安全性につき、トライアルグループは一切の保証をするものではありません。また、外部法人のソーシャルメディアの運用、ソフトウェアやモバイルアプリケーションの機能、ご利用方法や技術的な問い合わせに対しては、トライアルグループはお答えいたしかねます。
          </StyledListItem>
          <StyledListItem listType="article">
            本サービスからリンクするトライアルグループ以外のサイト（以下「リンクサイト」という）を利用されたことで利用者に生じた損害、リンクサイトの内容およびリンクサイトにおける個人情報の取り扱いについて、トライアルグループは責任を負いかねます。リンクサイトが中断もしくは停止したことにより、利用者が何らかの損害をこうむった場合でも、トライアルグループは何らの責任をも負わないものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            投稿・コメントに対してはその全てに返信するわけではありません。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループの公式発表・見解の発信は、トライアルグループのウェブサイト及びニュースリリース等で行っています。トライアルグループ及びトライアルグループ社員が本サービスにて発信する情報については、必ずしもトライアルグループの公式発表・見解を表すものではありません。また、利用者によって投稿されたユーザーコンテンツはトライアルグループとその従業員や関係者の意見や理想を反映しているわけではありません。トライアルグループは本サービスにおける文言や主張の正確性を保証することはありません。
          </StyledListItem>
          <StyledListItem listType="article">
            利用者が本サービスを利用して掲載した全ての情報について、トライアルグループが不適切と判断した場合には、トライアルグループは、当該利用者に対して理由を開示することなく、トライアルグループの裁量にて、当該情報の削除を行うことがあります。ただし、トライアルグループは、本項の規定をもって、本サービスに利用者が掲載する情報の監視及び検査を行うことを何ら保証するものではありません。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、利用者による本サービスの利用に起因又は関連して利用者が他の利用者又は第三者に及ぼした損害、及び第三者による本サービスの閲覧に起因又は関連して第三者が利用者に及ぼした損害（悪意を持った第三者が何らかの方法で個人情報を収集し、そのことによって、利用者が損害を被った場合を含む）について、一切の責任を負わないものとします。
          </StyledListItem>
          <StyledListItem listType="article">
            トライアルグループは、利用者に対し、本サービスの品質又は性能については如何なる保証も行いません。また、トライアルグループは、利用者に対し、本サービスの一時停止、中止、欠陥及びそれらに起因又は関連して発生した全ての損失や損害については、一切責任を負いません。
          </StyledListItem>
          <StyledListItem listType="article">
            事前にオンライン上にて告知を行った上で、本サービスの一部もしくは全てを終了し、データを消去することがあります。本サービスの終了により利用者及び第三者が被った被害について、トライアルグループは免責されるものとします。
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy11',
  },
  {
    children: (
      <>
        <p>
          制定日
          <ZenkakuSpace />
          2020年7月23日
          <br />
          最終改定日
          <ZenkakuSpace />
          2022年12月26日
        </p>
      </>
    ),
    id: 'signdate',
  },
]

export const snsLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（総則）',
      anchor: 'policy1',
    },
    {
      name: '（本規約の範囲）',
      anchor: 'policy2',
    },
    {
      name: '（利用者情報の取扱い）',
      anchor: 'policy3',
    },
  ],
  [
    {
      name: '（本規約の変更）',
      anchor: 'policy4',
    },
    {
      name: '（禁止事項）',
      anchor: 'policy5',
    },
    {
      name: '（禁止行為に対する措置）',
      anchor: 'policy6',
    },
  ],
  [
    {
      name: '（サ－ビスの変更）',
      anchor: 'policy7',
    },
    {
      name: '（知的財産権）',
      anchor: 'policy8',
    },
    {
      name: '（トライアルグループの利用）',
      anchor: 'policy9',
    },
  ],
  [
    {
      name: '（紛争の解決）',
      anchor: 'policy10',
    },
    {
      name: '（免責事項）',
      anchor: 'policy11',
    },
  ],
]
